import * as React from "react";
import * as Scrivito from "scrivito";
import { ObjValidator } from "components";

const HomepageSame = Scrivito.connect((props) => (
  <ObjValidator {...props}>{<div data-testid="homepage"></div>}</ObjValidator>
));

export default HomepageSame;
Scrivito.provideComponent("HomepageSame", HomepageSame);
